import { isOrderStatusWithPendingStock } from './orderStatus.js';
import { clean, day, inPeriod, numeric, sum } from './dashboardMetrics.js';
export const warehouseStatuses = { pending: 'Pendiente', processing: 'En preparación', partially_prepared: 'Parcialmente preparado', partially_served: 'Servido parcialmente' };
const sku = (row) => JSON.stringify([row.product_id, row.size, row.color]);
const knownPrice = (value) => value != null && value !== '' && Number.isFinite(Number(value));
export function warehousePendingRows(lines) {
  return lines.filter((r) => isOrderStatusWithPendingStock(r.order?.status) && numeric(r.pending_quantity) > 0).map((r) => {
    const quantity = numeric(r.pending_quantity);
    return { ...r, quantity, amount: knownPrice(r.price) ? quantity * Number(r.price) : null,
      prepared: Math.min(quantity, Math.max(0,numeric(r.preparation_quantity))),
      date: day(r.order.date), season: clean(r.product?.temporada),
      label: `${r.order.number ?? 'Sin número'} · ${r.product?.code || 'Sin artículo'}`,
      customer: r.order.customer?.name || 'Sin cliente', customerId: r.order.customer_id || '',
      detail: `${r.product?.description || ''} · ${r.size} / ${r.color}` };
  });
}
export function warehouseStockRows(inventory, pending) {
  const groups = new Map();
  const get = (row) => {
    const key = sku(row);
    if (!groups.has(key)) groups.set(key, { id:key, product_id:row.product_id, size:row.size, color:row.color, product:row.product, quantity:0, reserved:0, storedReserved:0, inventoryRows:0 });
    const group=groups.get(key); if(!group.product && row.product)group.product=row.product;return group;
  };
  for(const row of inventory){const group=get(row);group.quantity+=numeric(row.quantity);group.storedReserved+=numeric(row.pending_orders);group.inventoryRows++;}
  for(const row of pending){get(row).reserved+=row.quantity;}
  return [...groups.values()].map((r)=>({...r,season:clean(r.product?.temporada),label:r.product?.code || 'Sin artículo',detail:`${r.product?.description || ''} · ${r.size} / ${r.color}`,
    available:r.quantity-r.reserved, shortage:Math.max(0,r.reserved-r.quantity),
    amount:knownPrice(r.product?.price) ? r.quantity*Number(r.product.price) : null,
    reservationMismatch:r.storedReserved!==r.reserved,
  }));
}
export function filterWarehousePending(rows, filters) {
  return rows.filter((r)=>inPeriod(r.date,filters) && (!filters.season || r.season===filters.season) && (!filters.customer || r.customerId===filters.customer) && (!filters.status || r.order.status===filters.status));
}
export function warehouseOrderGroups(rows) {
  const groups=new Map();
  for(const row of rows){
    const id=row.order.id;
    const group=groups.get(id) || {id,number:row.order.number,date:row.date,delivery:row.order.fecha_entrega,status:row.order.status,customer:row.customer,quantity:0,prepared:0,amount:0,missingPrices:0,rows:[]};
    group.quantity+=row.quantity;group.prepared+=row.prepared;group.amount+=numeric(row.amount);if(row.amount==null)group.missingPrices++;group.rows.push(row);groups.set(id,group);
  }
  return [...groups.values()].sort((a,b)=>a.date.localeCompare(b.date) || String(a.number).localeCompare(String(b.number)));
}
export function warehouseTotals(pending,stock) {
  return {orders:new Set(pending.map((r)=>r.order.id)).size,quantity:sum(pending,'quantity'),pendingAmount:sum(pending,'amount'),prepared:sum(pending,'prepared'),
    stock:sum(stock,'quantity'),stockValue:sum(stock,'amount'),reserved:sum(stock,'reserved'),available:sum(stock,'available'),shortage:sum(stock,'shortage')};
}
